import { render } from "./DesktopDefault.vue?vue&type=template&id=35af4d04&scoped=true"
import script from "./DesktopDefault.vue?vue&type=script&lang=js"
export * from "./DesktopDefault.vue?vue&type=script&lang=js"

import "./DesktopDefault.vue?vue&type=style&index=0&id=35af4d04&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35af4d04"]])

export default __exports__